module.exports = __webpack_public_path__ + "static/media/bin.3752ea9a.svg";